
import { useEffect } from 'react';
import CommandCenter from './components/center/CommandCenter'
import Footer from './components/footer/Footer'
import CesiumProvider from './providers/CesiumProvider';
import ScenarioProvider from './providers/ScenarioProvider';
import ContactsProvider from './providers/ContactsProvider';
import './CommandCenterDashboard.css'
import ErrorProvider from './providers/ErrorProvider';
import ModalProvider from './providers/ModalProvider';
import OrbitProvider from './providers/OrbitProvider';
import SocketProvider from './providers/SocketProvider';
import LoaderProvider from './providers/loader_provider/LoaderProvider';
import CommandCenterStateProvider from './providers/CommandCenterStateProvider';
import Header from './components/header/Header';
import HwilProvider from './providers/HwilProvider';
import FilesProvider from './providers/FilesProvider';
import TelemetryProvider from './providers/TelemetryProvider';


const CommandCenterDashboard = () => {

  // const [socket, setSocket] = useState<WebSocket | null>(null);
  // const [messages, setMessages] = useState<any>([]);


  // const create_socket = (simulationId, sessionId) => {
  //   return new WebSocket(`ws://10.11.11.34:21000/ws/test/simulation/websocketstatus?simulationId=${simulationId}&sessionId=${sessionId}`);
  // }

  // Websocket connection for simulation status //

  // useEffect(() => {
  //   const token = sessionStorage.getItem("authentication");
  //   if (scenario?.['simulationId'] && token) {
  //     const sessionId = uuidv4();
  //     let ws = create_socket(scenario?.['simulationId'], sessionId)
  //     ws.onopen = () => {
  //       ws.send(JSON.stringify({ type: 'authorization', token: `${token}` }));
  //       console.log('WebSocket Connected');
  //     };
  //     ws.onmessage = (event) => {
  //       const message = JSON.parse(event.data);
  //       // console.log(message);
  //       setMessages((prevMessages) => [...prevMessages, message]);
  //     };

  //     ws.onclose = () => {
  //       console.log('WebSocket Disconnected');
  //     };

  //     ws.onerror = (error) => {
  //       console.error('WebSocket Error:', error);
  //       let ws = create_socket(scenario?.['simulationId'], sessionId)
  //     };

  //     setSocket(ws);

  //     return () => {
  //       ws.close();
  //     };
  //   }
  // }, [scenario]);

  useEffect(() => {
    return () => {
      if (sessionStorage.getItem('modals')) {
        sessionStorage.removeItem('modals')
      }
    };
  }, [])

  return (
    <CommandCenterStateProvider>
      <ErrorProvider>
        <LoaderProvider>
          <SocketProvider>
            <ScenarioProvider>
              <HwilProvider>
                <CesiumProvider>
                  <ContactsProvider>
                    <OrbitProvider>
                      <FilesProvider>
                        <TelemetryProvider>
                          <div className='command__center_dashboard'>
                            <ModalProvider>
                              <Header />
                              <CommandCenter />
                              <Footer />
                            </ModalProvider>
                          </div>
                        </TelemetryProvider>
                      </FilesProvider>
                    </OrbitProvider>
                  </ContactsProvider>
                </CesiumProvider>
              </HwilProvider>
            </ScenarioProvider>
          </SocketProvider>
        </LoaderProvider>
      </ErrorProvider>
    </CommandCenterStateProvider>
  )
}

export default CommandCenterDashboard